import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { muiTheme } from './theme/MuiTheme';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Technology from './pages/Technology';
import Transparency from './pages/Transparency';
import Developers from './pages/Developers';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';

function App() {
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline /> {/* Resets default browser styles */}
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/transparency" element={<Transparency />} />
          <Route path="/developers" element={<Developers />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;